import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  container: {
    padding: '15px',
    paddingBlockStart: '40px',
  },
  iconContainer: {
    textAlign: 'center',
  },
  icon: {
    width: '50px',
    height: '50px',
  },
});

export default useStyles;
